import { deviceManager } from '@hid/device/device_manager'
import { dataProfileManage } from '@hid/snapshot/profile'
import { MusicSocket } from '@libs/music/music_socket'
import { PostDynamicColor } from '@libs/types/response'

export const handleDynamicColor = async (post: PostDynamicColor): Promise<boolean> => {
  const config = dataProfileManage().dataProfile
  config.ColorsDynamic.Color = post.Color
  config.ColorsDynamic.FullColor = post.FullColor
  config.ColorsDynamic.Mode = post.Mode
  config.ColorsDynamic.Run = post.Run
  config.ColorsDynamic.IsEEvision = post.IsEEvision
  config.LightLastIsCustom = false
  // config.LightMode.Light = post.Light
  dataProfileManage().save()
  return await deviceManager.deviceDriver.syncDynamicColor()
}

export const handleCheckEnableDynamicColor = async (): Promise<boolean> => {
  const ins = await MusicSocket.getIns()
  if (!ins.checkSocket()) {
    return false
  }
  const res = await ins.checkSocketVersion()
  return res
}
